import {Route, Routes} from "react-router";
import React from "react";
import HomePage from "./views";
import {routes, routesBlack, routesV3, routesFull, routesV4} from "./routes";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import ResultPage from "./views/result/ResultPage";

function App() {

    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 30 * 1000,
                refetchOnWindowFocus: false,
                retry: 1,
            },
        },
    });

    return (
        <QueryClientProvider client={queryClient}>
            <Routes>
                <Route index path="/" element={<HomePage routes={routes} showResultButton/>}/>
                <Route index path="/black" element={<HomePage routes={routesBlack}/>}/>
                <Route index path="/live-v3" element={<HomePage routes={routesV3} showResultButton/>}/>
                <Route path="/live-full" element={<HomePage routes={routesFull} showResultButton/>}/>
                <Route path="/live-v4" element={<HomePage routes={routesV4} showResultButton/>}/>
                <Route path="/result/:lotteryType" element={<ResultPage />} />
                <Route path="/app/result/:type" element={<ResultPage hideBackButton />} />
                {[...routes, ...routesBlack, ...routesV3].map((route, index) => {
                    return <Route key={index} path={route.path} element={route.element}/>
                })}
                {[...routesFull, ...routesV4].map(route => <Route key={route.path} path={route.path} element={route.element} />)}
            </Routes>
        </QueryClientProvider>
    )
}

export default App;
